
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"loadingError":"An error occurred while loading popup window","emptyContent":"No content available"},"de":{"loadingError":"Beim Laden des Fensterinhalts ist ein Fehler aufgetreten","emptyContent":"Kein Fensterinhalt verfügbar"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();